export default __webpack_public_path__ + "static/media/things-to-do.fc43d26d.jpg";